<template>
  <v-row :class="defaultMargin">
    <v-card flat>
      <v-card-title class="text-display-4">{{ title }}</v-card-title>
      <v-card-text>
        <div class="text-body-2">
          {{ text }}
        </div>
      </v-card-text>
    </v-card>
  </v-row>
</template>

<script>
export default {
  props: {
    defaultMargin: {
      type: String,
    },
    title: {
      type: String,
    },
    text: {
      type: String,
    },
  },
};
</script>
